module.exports = __webpack_public_path__ + "img/dl006x1.prt.fee82480.jpg";